import { render } from "./ArticleModal.vue?vue&type=template&id=feb675da&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"

import "./ArticleModal.vue?vue&type=style&index=0&id=feb675da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feb675da"]])

export default __exports__